<div class="modal-headerNew">
    <div class="w-100 text-center">
        <i class="fa-solid fa-triangle-exclamation" style="font-size: 50px; color: #E81D25;"></i>
    </div>
</div>
<div class="modal-body" style="padding: 0px 30px 15px 30px;">
    <h4 class="modal-title" style="display: flex; justify-content: center;">
        {{title}}
    </h4>
    <div style="display: flex; justify-content: center;">{{ message }}</div>
    <span *ngIf="reason">
        <label class="mt-4"><b>{{ 'Vehicle-Details.remarks' | translate }}</b></label>
        <textarea class="form-control" [(ngModel)]="reasonModel" rows="5"></textarea>
    </span>
</div>
<div class="modal-footer">
    <button type="button" class="btn secondary-btn" (click)="cancel()" *ngIf="data?.cancel">
    <span>{{'Withdraw-Orders.cancel' | translate}}</span>
    </button>
    <button type="button" class="btn primary-btn" (click)="confirm()" *ngIf="data?.confirm && !data?.ok">
    <span>{{'Withdraw-Orders.confirm' | translate}}</span>
    </button>
    <button type="button" class="btn primary-btn" (click)="cancel()" *ngIf="data?.ok && !data?.confirm">
    <span>{{'Withdraw-Orders.ok' | translate}}</span>
    </button>

</div>